/* eslint-disable wix-custom-rules/wixstores-file-names */
import type {CustomCssVarsFnParams, ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {CategoryListItemsToShow, CategoryListLayout} from '../../constants';

export const extendedGridGalleryCustomCssVars = ({styleParams: styles, isMobile}: CustomCssVarsFnParams) => {
  const verticalCategoryList = styles.numbers.gallery_categoryListLayout === CategoryListLayout.Vertical && !isMobile;
  const {gallery_showCategories, galleryShowFilters} = styles.booleans;
  const {gallery_layoutHorizontalPadding} = styles.numbers;
  const showSidePanel = (gallery_showCategories && verticalCategoryList) || galleryShowFilters;

  return {
    extendedGalleryInlineStartPadding: showSidePanel && !isMobile ? '20px' : `${gallery_layoutHorizontalPadding}px`,
  };
};

/* istanbul ignore file */
export const extendedGridGalleryShouldRenderVars = ({numbers, booleans, isMobile}: ShouldRenderVarsFnParams) => {
  const verticalCategoryList = numbers.gallery_categoryListLayout === CategoryListLayout.Vertical && !isMobile;
  const {gallery_showCategories, galleryShowFilters, galleryShowSort} = booleans;
  const includeSiblingsInCategoryList = numbers.gallery_categoryListItemsToShow === CategoryListItemsToShow.ShowAll;

  return {
    showSidePanel: (gallery_showCategories && verticalCategoryList) || galleryShowFilters,
    showSidePanelWithoutFilters: gallery_showCategories && verticalCategoryList,
    showHorizontalCategoryList: gallery_showCategories && !verticalCategoryList,
    showHorizontalCategoryListWhenNoSubcategories:
      gallery_showCategories && !verticalCategoryList && includeSiblingsInCategoryList,
    shouldShowMobileFiltersOrSort: galleryShowSort || galleryShowFilters,
  };
};
